<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="visibilities" formControlName="visibility" optionLabel="name"
            optionValue="value" placeholder="visibility"></p-dropdown>
            <label for="visibility">visibility</label>
            @for (validation of validationMessages.visibility; track validation) {
              <span>
                @if (form1.get('visibility').hasError(validation.type) && (form1.get('visibility').dirty || form1.get('visibility').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="tagTypes" formControlName="tagType" optionLabel="name"
            optionValue="value" placeholder="tagType"></p-dropdown>
            <label for="tagType">tagType</label>
            @for (validation of validationMessages.tagType; track validation) {
              <span>
                @if (form1.get('tagType').hasError(validation.type) && (form1.get('tagType').dirty || form1.get('tagType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown
              class="w-100"
              inputId="tagGroupCategoryPreset"
              formControlName="tagGroupCategoryPreset"
              [options]="tagGroupCategoryOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Tag group category"
              [showClear]="true"
              appendTo="body"
              dropdownIcon="fa fa-caret-down">
            </p-dropdown>
            <label for="tagGroupCategoryPreset">Tag group category</label>
          </span>
          @if (isTagGroupCategoryOther()) {
            <span class="p-float-label required-field w-100 mb-3">
              <input formControlName="tagGroupCategoryOther" id="tagGroupCategoryOther" type="text" pInputText>
              <label for="tagGroupCategoryOther">Specify category</label>
            </span>
          }
          @if (form1.hasError('tagGroupCategoryOtherRequired') && form1.touched) {
            <small class="p-invalid d-block mb-2">Enter a category when Other is selected.</small>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText>
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- R1 (Approach A) — Triggered by Order Product.
             Only shown for reservation tags (tagType=8). For other tag types
             (folder, project, property, etc.) OP-triggering doesn't apply, so
             we hide the field to avoid confusion. -->
        @if (showOrderProductField) {
          <div class="col-lg-12">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100"
                          formControlName="orderProductId"
                          [options]="orderProductOptions"
                          optionLabel="label" optionValue="value"
                          placeholder="(none — not auto-fired)"
                          [filter]="true" filterBy="label"
                          [showClear]="true" appendTo="body"
                          dropdownIcon="fa fa-caret-down">
              </p-dropdown>
              <label for="orderProductId">Triggered by Order Product</label>
            </span>
            <small class="text-muted" style="display:block; margin-top:-8px; margin-bottom:10px;">
              When set, this tag is auto-applied whenever the selected order product is added to a reservation.
            </small>
          </div>
        }

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
            <label for="description">Description</label>
            @for (validation of validationMessages.description; track validation) {
              <span>
                @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- R6 — Breezeway Tag ID assignment (only meaningful for tagType=8 reservation tags,
             but we render it for all so admins can fix legacy data). -->
        @if (tagId) {
          <div class="col-lg-12">
            <hr style="margin: 8px 0;">
            <div class="row m-0">
              <div class="col-lg-6">
                <span class="p-float-label w-100 mb-3">
                  <input formControlName="breezewayTagId" id="breezewayTagId" type="number" pInputText>
                  <label for="breezewayTagId">Breezeway Tag ID</label>
                </span>
              </div>
              <div class="col-lg-6 d-flex align-items-center">
                <button pButton type="button" class="p-button-outlined p-button-sm"
                        style="margin-right:8px;"
                        (click)="toggleBreezewayPicker()">
                  {{ breezewayPickerOpen ? 'Hide picker' : 'Pick from Breezeway…' }}
                </button>
                <button pButton type="button" class="p-button-sm"
                        (click)="saveBreezewayTagId()"
                        pTooltip="Validate and save the Breezeway tag id (requires the property id used for the lookup)."
                        tooltipPosition="top">
                  Save Breezeway ID
                </button>
              </div>
            </div>

            @if (breezewayPickerOpen) {
              <div class="row m-0" style="background:#f7f9fb; padding:10px; border-radius:6px;">
                <div class="col-lg-6">
                  <span class="p-float-label w-100 mb-2">
                    <input id="bwPropId" type="number" pInputText
                           [(ngModel)]="breezewayPropertyId"
                           [ngModelOptions]="{standalone: true}">
                    <label for="bwPropId">Breezeway Property ID</label>
                  </span>
                </div>
                <div class="col-lg-6 d-flex align-items-center">
                  <button pButton type="button" class="p-button-outlined p-button-sm"
                          [disabled]="breezewayTagsLoading"
                          (click)="loadBreezewayTagsForProperty()">
                    @if (breezewayTagsLoading) {
                      <i class="pi pi-spin pi-spinner" style="margin-right:6px;"></i>
                    }
                    Load tags for property
                  </button>
                </div>

                @if (breezewayTagsError) {
                  <div class="col-lg-12">
                    <small class="p-invalid">{{ breezewayTagsError }}</small>
                  </div>
                }

                @if (breezewayTagOptions.length > 0) {
                  <div class="col-lg-12 mt-2">
                    <span class="p-float-label w-100 mb-2">
                      <p-dropdown class="w-100"
                                  [options]="breezewayTagOptions"
                                  optionLabel="label" optionValue="value"
                                  placeholder="Pick a Breezeway tag"
                                  [showClear]="true" appendTo="body"
                                  (onChange)="onBreezewayTagPicked($event.value)">
                      </p-dropdown>
                    </span>
                    <small class="text-muted">After picking, click <b>Save Breezeway ID</b> above.</small>
                  </div>
                }
              </div>
            }

            @if (breezewayWarning) {
              <div class="col-lg-12 mt-2">
                <div style="background:#fff3cd; border:1px solid #ffe69c; padding:6px 10px; border-radius:4px;">
                  <i class="pi pi-exclamation-triangle" style="color:#856404; margin-right:6px;"></i>
                  <small style="color:#856404;">{{ breezewayWarning }}</small>
                </div>
              </div>
            }
          </div>
        }

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (tagId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!tagId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (tagId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
